import React from "react";
import ModalTemplate from "../../common/components/ModalTemplate";
import PropTypes from "prop-types";
import Button from "../../common/components/Button";
import RetakeWarnings from "../constants/RetakeWarnings";
import LoadingSpinner from "../../common/components/LoadingSpinner";

const ConfirmationModal = ({
  isOpen,
  onClose,
  isRefresh,
  prepareTime,
  answerTime,
  retakeCount,
  retakeType,
  managerRef,
}) => {
  const handleBeginInterview = async () => {
    try {
      // Get stream only when user clicks Begin Interview
      const { stream } = await managerRef.current.askForPermissions();
      onClose("confirm", stream);
    } catch (error) {
      console.error("Failed to initialize stream:", error);
      onClose("error", error);
    }
  };

  const retakeWarning = RetakeWarnings(
    retakeType,
    retakeCount,
    prepareTime,
    answerTime
  );

  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      title={isRefresh ? "Refresh detected" : "Confirm you are ready to begin"}
      subtitle={
        isRefresh
          ? "Your interview will resume from the last question you left off, losing a retake (if applicable)."
          : "Once the interview starts, you may not pause and will not have the chance to restart."
      }
      showCloseButton={false}
      maxWidth="lg"
    >
      <div className="space-y-4">
        <p className="text-red-500 font-semibold">
          Do NOT leave the page or refresh the browser while interviewing.
        </p>
        {retakeWarning ? retakeWarning : <LoadingSpinner />}

        <div className="flex justify-end space-x-2 pt-4">
          <Button text="Cancel" onClick={() => onClose("cancel")} color="red" />
          <Button
            text={isRefresh ? "Resume Interview" : "Begin Interview"}
            color="primary"
            onClick={handleBeginInterview}
          />
        </div>
      </div>
    </ModalTemplate>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isRefresh: PropTypes.bool,
  prepareTime: PropTypes.number,
  answerTime: PropTypes.number.isRequired,
  retakeCount: PropTypes.number,
  retakeType: PropTypes.string.isRequired,
  managerRef: PropTypes.object.isRequired,
};

export default ConfirmationModal;
